<div
  class="img-card img-card--alignment-{{ alignment }}"
  [style.background-image]="backgroundUrl()"
  [style.aspect-ratio]="aspectRatio"
>
  <div
    class="img-card-overlay"
    [style.background-color]="backgroundColor"
  ></div>
  <div class="img-card-info-container">
    <div class="img-card-tag-container">
      <div *ngIf="tag" class="img-card-tag" [style.background-color]="tagColor">
        {{ tag }}
      </div>
    </div>
    <div class="img-card-info">
      <div class="img-card-title">{{ title }}</div>
      <div class="img-card-subtitle">{{ subtitle }}</div>
    </div>
  </div>
</div>
